import styles from './ScommesseFiltersListSecondary.module.scss';

export type ScommesseFiltersListSecondaryProps = {
  isOpen?: boolean;
  className?: string;
  children?: React.ReactNode;
  noSidePadding?: boolean;
  noRightPadding?: boolean;
};

export const ScommesseFiltersListSecondary = ({
  isOpen,
  className,
  children,
  noSidePadding,
  noRightPadding,
}: ScommesseFiltersListSecondaryProps) => {
  return (
    <div
      className={`${styles.container} ${isOpen ? styles.visible : styles.hidden} ${className ? className : ''} ${
        noSidePadding ? styles.noSidePadding : ''
      } ${noRightPadding ? styles.noRightPadding : ''} ${children && children[0] === false ? styles.flexEnd : ''}`}
    >
      {children}
    </div>
  );
};
